import { ThemeEvents } from '@theme/events';
import {
  formatMoney,
  resetMoneyElementForConverter,
  stripThousandSeparatorsForConverter,
} from '@theme/money-formatting';
import { refreshCurrencyConversion } from './currency-converter-refresh.js';

const FREE_SHIPPING_SELECTOR = '[data-free-shipping-header]';

/** Same basis as cart-summary "Odhadovaný součet" (`cart.total_price`). */
const getEstimatedCartTotalCents = (cart) => {
  if (!cart) return 0;
  return Math.max(0, Number(cart.total_price ?? 0));
};

const formatRemaining = (value, container) => {
  const moneyFormat = container.dataset.moneyFormat || '{{amount}}';
  const currency = container.dataset.currency || window.Shopify?.currency?.shopCurrency || 'CZK';
  const formatted = formatMoney(value, moneyFormat, currency);

  return stripThousandSeparatorsForConverter(formatted);
};

const isShopCurrencyText = (text) => /Kč|CZK\b/i.test(text ?? '');

const getHoppyActiveCurrency = () =>
  sessionStorage.getItem('currentCurrency') || window.Shopify?.currency?.shopCurrency || 'CZK';

const shouldConvertFreeShippingAmount = () => {
  const shopCurrency = window.Shopify?.currency?.shopCurrency || 'CZK';
  return getHoppyActiveCurrency() !== shopCurrency;
};

const reconvertStuckFreeShippingAmounts = () => {
  if (!shouldConvertFreeShippingAmount()) return;

  document.querySelectorAll(`${FREE_SHIPPING_SELECTOR} [data-free-shipping-amount] .money`).forEach((element) => {
    if (isShopCurrencyText(element.textContent)) {
      resetMoneyElementForConverter(element);
    }
  });

  refreshCurrencyConversion(document);
};

const setRemainingAmount = (amountEl, remaining, container) => {
  const formatted = formatRemaining(remaining, container);
  let moneyWrapper = amountEl.querySelector('.money');

  if (!moneyWrapper) {
    amountEl.innerHTML = `<span class="money">${formatted}</span>`;
    moneyWrapper = amountEl.querySelector('.money');
  } else {
    resetMoneyElementForConverter(moneyWrapper);
    moneyWrapper.textContent = formatted;
  }

  if (moneyWrapper) {
    refreshCurrencyConversion(amountEl);
    window.setTimeout(reconvertStuckFreeShippingAmounts, 100);
  }
};

const updateContainer = (container, cart, { updateAmount = true } = {}) => {
  if (!container || !cart) return;

  const threshold = Number(container.dataset.threshold || 0);
  if (!threshold) return;

  const total = getEstimatedCartTotalCents(cart);
  const hasFreeShipping = total >= threshold;
  const remaining = Math.max(threshold - total, 0);
  const progressPercent = hasFreeShipping ? 100 : Math.min(100, Math.round((total / threshold) * 100));

  const reachedEl = container.querySelector('[data-free-shipping-reached]');
  const remainingEl = container.querySelector('[data-free-shipping-remaining]');
  const amountEl = container.querySelector('[data-free-shipping-amount]');
  const barEl = container.querySelector('.bar');

  if (reachedEl) reachedEl.classList.toggle('hidden', !hasFreeShipping);
  if (remainingEl) remainingEl.classList.toggle('hidden', hasFreeShipping);
  if (barEl) barEl.style.width = `${progressPercent}%`;

  if (updateAmount && amountEl && !hasFreeShipping) {
    setRemainingAmount(amountEl, remaining, container);
  }
};

const syncProgressBarsFromCartApi = async () => {
  try {
    const cart = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`).then((response) => response.json());
    if (typeof cart?.total_price !== 'number') return;

    document.querySelectorAll(FREE_SHIPPING_SELECTOR).forEach((container) => {
      updateContainer(container, cart, { updateAmount: false });
    });
  } catch {
    // cart.js unavailable — keep SSR values
  }
};

const onCartUpdate = (event) => {
  const cart = event.detail?.resource;
  if (typeof cart?.total_price !== 'number') return;

  document.querySelectorAll(FREE_SHIPPING_SELECTOR).forEach((container) => {
    updateContainer(container, cart, { updateAmount: true });
  });
};

/** Re-run Hoppy on free-shipping amounts after currency switch (SSR values stay in shop currency). */
const onCurrencySwitch = () => {
  window.setTimeout(reconvertStuckFreeShippingAmounts, 100);
};

document.addEventListener(ThemeEvents.cartUpdate, onCartUpdate);
document.addEventListener('DOMContentLoaded', () => {
  syncProgressBarsFromCartApi();
  window.setTimeout(reconvertStuckFreeShippingAmounts, 250);
});
document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('.futureblink-currency-dropdown .option')) {
    onCurrencySwitch();
  }
});
